import { SelectBoxUtils } from "./utilities.select-boxes"

/**
 * Search sort order control controller.
 * 
 * @since 1.0.0
 * @package dealerkit-wp
 */
export class SortController
{
    constructor(core, $container, id) {
        this.core = core

        this.$container = $container

        this.id = id

        this.utils = new SelectBoxUtils(this.core.window.document)

        this.core.container.make('search.service').then(search => {
            this.search = search
        })

        this.core.events.on('search.before', () => {
            this.utils.setOption(this.$control, this.search.params().sort_by)
        })

        this.$control = this.$container.querySelector('select')
    }

    render() {
        this.$control.addEventListener('change', e => {
            this.search.setParam('sort_by', e.target.value)
            this.search.setParam('page', 1)
            this.search.search()
        })
    }
}